import { client } from "./client.gen";
export const identityCreateUser = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/users/register",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityDeleteDealerProxyToken = (options) => {
    return (options?.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auth/dealer-proxy-tokens",
        ...options,
    });
};
export const identityCreateDealerProxyToken = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/auth/dealer-proxy-tokens",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateUserSession = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/users/login",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateUserTokenRefresh = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/refresh",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityGetUser = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}",
        ...options,
    });
};
export const identityUpdateProfile = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/profile",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityGetProfileImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/profile-images/upload-url",
        ...options,
    });
};
export const identityUpdateNotificationSettings = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/notification-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityUpdatePhoneNumber = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/phone-number",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreatePhoneVerification = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/verify-phone",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreatePhoneVerificationCode = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/phone-verification-codes",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityDeleteUserAccount = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/withdraw",
        ...options,
    });
};
export const identityGetInterestCategories = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/interest-categories",
        ...options,
    });
};
export const identityUpdateInterestCategories = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/interest-categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identitySearchUsers = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/search",
        ...options,
    });
};
export const identityCreateAdminSession = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/admin/auth/login",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateAdminTokenRefresh = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/admin/auth/refresh",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateUserSuspension = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/admin/users/{userId}/suspend",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityListAdminAccounts = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-accounts",
        ...options,
    });
};
export const identityCreateAdminAccount = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-accounts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityDeleteAdminAccount = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-accounts/{adminId}",
        ...options,
    });
};
export const identityGetAdminAccount = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-accounts/{adminId}",
        ...options,
    });
};
export const identityUpdateAdminAccount = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-accounts/{adminId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityUpdateAdminPassword = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-accounts/{adminId}/password",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityListAdminLoginLocks = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-login-locks",
        ...options,
    });
};
export const identityCreateAdminLoginLockRelease = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-login-locks/{lockId}/release",
        ...options,
    });
};
export const identityListUserAccounts = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users",
        ...options,
    });
};
export const identityGetBackofficeUserAccount = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}",
        ...options,
    });
};
export const identityCreateUserActivation = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/activate",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateBackofficeDealerProxySession = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/dealer-proxy-sessions",
        ...options,
    });
};
export const identityUpdateBackofficeUserProfileImage = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/profile-images",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityGetBackofficeProfileImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/profile-images/upload-url",
        ...options,
    });
};
export const identityCreateBackofficeGrantDealerPermission = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/grant-dealer-permission",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateBackofficeRevokeDealerPermission = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/revoke-dealer-permission",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateBackofficeForceNicknameChange = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/force-change-nickname",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityListBackofficeUserAdminMemos = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/admin-memos",
        ...options,
    });
};
export const identityCreateBackofficeUserAdminMemo = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/admin-memos",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityGetBackofficeNotificationSettingsSummary = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-settings/summary",
        ...options,
    });
};
export const identityGetBackofficeAppVersionSummary = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/app-installations/summary",
        ...options,
    });
};
export const identityListBackofficeUserHistories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/user-histories",
        ...options,
    });
};
export const identityListAdminHistories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/admin-histories",
        ...options,
    });
};
export const identityListDealerHistories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/dealer-histories",
        ...options,
    });
};
export const identityGetBackofficeUserInterestCategories = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/interest-categories",
        ...options,
    });
};
export const identityUpdateBackofficeUserInterestCategories = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/interest-categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateBackofficeInterestCategoryRepromptRequest = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/interest-categories/reprompt-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateBackofficeDatabaseReset = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/backoffice/database/resets",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateKakaoSession = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/public/auth/kakao/login",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateNaverToken = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/public/auth/naver/exchange",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateSocialSession = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/public/auth/social/login",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateSocialSignup = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/public/auth/social/signup",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityDeleteDeviceToken = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/device-tokens",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const identityCreateDeviceToken = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/device-tokens",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingListBackofficeUserBroadcastTelemetrySessions = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/broadcast-telemetry-sessions",
        ...options,
    });
};
export const identityUpdateAppInstallation = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/app-installations/{installationId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersListOrders = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders",
        ...options,
    });
};
export const ordersCreateOrder = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateOrderCancellation = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersGetOrder = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}",
        ...options,
    });
};
export const ordersCreateOrderRepayment = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}/repay",
        ...options,
    });
};
export const ordersCreateOrderShippingFeeRefund = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}/shipping-fee-refund",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateFulfillmentOrderConfirmation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/confirm",
        ...options,
    });
};
export const ordersPatchFulfillmentOrderDelivery = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/deliver",
        ...options,
    });
};
export const ordersCreateFulfillmentOrderConfirmationRequest = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/confirmation-requests",
        ...options,
    });
};
export const ordersGetFulfillmentOrder = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}",
        ...options,
    });
};
export const ordersListMyFulfillmentOrders = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/mine",
        ...options,
    });
};
export const ordersListReceivedFulfillmentOrders = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/received",
        ...options,
    });
};
export const ordersGetFulfillmentOrderCounts = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/counts",
        ...options,
    });
};
export const ordersListReturns = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}/returns",
        ...options,
    });
};
export const ordersCreateReturn = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}/returns",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersGetReturn = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}/returns/{returnId}",
        ...options,
    });
};
export const ordersPatchReturnApproval = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/returns/{returnId}/approve",
        ...options,
    });
};
export const ordersPatchReturnRejection = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/returns/{returnId}/reject",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersGetReturnImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/returns/images/upload-url",
        ...options,
    });
};
export const ordersListMyReturns = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/returns/mine",
        ...options,
    });
};
export const ordersListReceivedReturns = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/returns/received",
        ...options,
    });
};
export const ordersGetShipment = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/shipments/{shipmentId}",
        ...options,
    });
};
export const ordersListDeliveryAddresses = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/delivery-addresses",
        ...options,
    });
};
export const ordersCreateDeliveryAddress = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/delivery-addresses",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersDeleteDeliveryAddress = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/delivery-addresses/{addressId}",
        ...options,
    });
};
export const ordersGetDeliveryAddress = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/delivery-addresses/{addressId}",
        ...options,
    });
};
export const ordersUpdateDeliveryAddress = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/delivery-addresses/{addressId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateDeliveryAddressDefault = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/delivery-addresses/{addressId}/set-default",
        ...options,
    });
};
export const ordersListBuyerOrders = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/buyers/{buyerId}/orders",
        ...options,
    });
};
export const ordersListUserDeliveryAddresses = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/delivery-addresses",
        ...options,
    });
};
export const ordersListMyOrders = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/mine",
        ...options,
    });
};
export const ordersListReceivedOrders = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/received",
        ...options,
    });
};
export const ordersGetReceivedOrdersAnnualSales = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/received/annual-sales",
        ...options,
    });
};
export const ordersListBackofficeOrders = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/orders",
        ...options,
    });
};
export const ordersGetBackofficeOrder = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/orders/{orderId}",
        ...options,
    });
};
export const ordersCreateBackofficeOrderForceCancelRefund = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/orders/{orderId}/force-cancel-refund",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateBackofficeOrderShippingFeeRefund = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/orders/{orderId}/shipping-fee-refund",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersListBackofficeUserDeliveryAddresses = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/delivery-addresses",
        ...options,
    });
};
export const ordersListBackofficeReturns = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/returns",
        ...options,
    });
};
export const ordersGetBackofficeReturn = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/returns/{returnId}",
        ...options,
    });
};
export const ordersCreateBackofficeReturnForceApproveRefund = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/returns/{returnId}/force-approve-refund",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersListBackofficeShipments = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/shipments",
        ...options,
    });
};
export const ordersGetBackofficeShipment = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/shipments/{shipmentId}",
        ...options,
    });
};
export const ordersListBackofficeFulfillmentOrders = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/fulfillment-orders",
        ...options,
    });
};
export const ordersGetBackofficeFulfillmentOrder = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/fulfillment-orders/{fulfillmentOrderId}",
        ...options,
    });
};
export const ordersCreateBackofficeFulfillmentOrderForceCancelRefund = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/fulfillment-orders/{fulfillmentOrderId}/force-cancel-refund",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersUpdateBackofficeFulfillmentOrderShipmentTracking = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/fulfillment-orders/{fulfillmentOrderId}/shipments/tracking-records",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersUpdateBackofficeFulfillmentOrderShippingAddress = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/fulfillment-orders/{fulfillmentOrderId}/shipping-address",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateFulfillmentOrderShipment = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/ship",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersUpdateFulfillmentOrderShippingAddress = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/shipping-address",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersListFulfillmentOrderBuyerDeliveryAddresses = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/buyer-delivery-addresses",
        ...options,
    });
};
export const ordersGetFulfillmentOrderTrackingStatus = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/tracking-status",
        ...options,
    });
};
export const ordersUpdateFulfillmentOrderShipmentTracking = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/shipments/tracking-records",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateTrackingValidation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/tracking-validations",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateOrderCancellationRequest = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/orders/{orderId}/cancellation-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateFulfillmentOrderCancellationRequest = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/cancellation-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateFulfillmentOrderBatchCancellationRequest = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/batch-cancellation-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersCreateFulfillmentOrderReturnRequest = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/fulfillment-orders/{fulfillmentOrderId}/return-requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersGetReceivedCancellationRequest = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/cancellation-requests/{cancellationId}",
        ...options,
    });
};
export const ordersPatchCancellationRequestApproval = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/cancellation-requests/{cancellationId}/approve",
        ...options,
    });
};
export const ordersPatchCancellationRequestRejection = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/cancellation-requests/{cancellationId}/reject",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ordersListReceivedCancellationRequests = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/cancellation-requests/received",
        ...options,
    });
};
export const ordersCreateCancellationRequestBatchApproval = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/cancellation-requests/batch-approvals",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const paymentListPayments = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payments",
        ...options,
    });
};
export const paymentGetPaymentDetails = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payments/{paymentId}",
        ...options,
    });
};
export const paymentCreatePaymentRefund = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payments/{paymentId}/refund",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const paymentGetRefundStatus = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/refunds/{refundId}",
        ...options,
    });
};
export const paymentListPaymentMethods = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payment-methods",
        ...options,
    });
};
export const paymentCreatePaymentMethod = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payment-methods",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const paymentDeletePaymentMethod = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payment-methods/{paymentMethodId}",
        ...options,
    });
};
export const paymentGetPaymentMethod = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payment-methods/{paymentMethodId}",
        ...options,
    });
};
export const paymentCreatePaymentMethodDefault = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/payment-methods/{paymentMethodId}/set-default",
        ...options,
    });
};
export const paymentCreateAuthorize = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/webhooks/payment/authorize",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const paymentListBackofficePayments = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/payments",
        ...options,
    });
};
export const paymentGetBackofficePayment = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/payments/{paymentId}",
        ...options,
    });
};
export const paymentListBackofficeRefunds = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/refunds",
        ...options,
    });
};
export const paymentGetBackofficeRefund = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/refunds/{refundId}",
        ...options,
    });
};
export const paymentCreateBackofficeRefundForceProcess = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/refunds/{refundId}/force-process",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogListProducts = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/products",
        ...options,
    });
};
export const productCatalogCreateProduct = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogDeleteProduct = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}",
        ...options,
    });
};
export const productCatalogGetProduct = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/products/{productId}",
        ...options,
    });
};
export const productCatalogUpdateProductDetails = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/details",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogUpdateProductImages = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/images",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogUpdateProductPricing = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/pricing",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogPatchProductPublishStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/publish",
        ...options,
    });
};
export const productCatalogGetProductImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/images/upload-url",
        ...options,
    });
};
export const productCatalogPatchProductArchiveStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/archive",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogPatchProductHideStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/hide",
        ...options,
    });
};
export const productCatalogPatchProductUnhideStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/unhide",
        ...options,
    });
};
export const productCatalogUpdateProductCategories = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogPatchProductSalesChannel = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/sales-channel",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogCreateGroupBuy = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/products/{productId}/group-buys",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogListProductsByBroadcast = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/broadcasts/{broadcastId}/products",
        ...options,
    });
};
export const productCatalogListGroupBuys = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/group-buys",
        ...options,
    });
};
export const productCatalogGetGroupBuy = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/group-buys/{groupBuyId}",
        ...options,
    });
};
export const productCatalogCreateGroupBuySlotReservation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/group-buys/{groupBuyId}/reserve",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogCreateGroupBuySlotRelease = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/group-buys/{groupBuyId}/release",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogCreateGroupBuyBreak = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/group-buys/{groupBuyId}/break",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const productCatalogCreateGroupBuyActivation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/group-buys/{groupBuyId}/activate",
        ...options,
    });
};
export const productCatalogListBackofficeProducts = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/products",
        ...options,
    });
};
export const productCatalogDeleteBackofficeProduct = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/products/{productId}",
        ...options,
    });
};
export const productCatalogGetBackofficeProduct = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/products/{productId}",
        ...options,
    });
};
export const productCatalogPatchBackofficeProductHideStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/products/{productId}/hide",
        ...options,
    });
};
export const productCatalogPatchBackofficeProductUnhideStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/products/{productId}/unhide",
        ...options,
    });
};
export const productCatalogUpdateBackofficeProductCertification = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/products/{productId}/certification",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesListAuctions = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/auctions",
        ...options,
    });
};
export const salesCreateAuction = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateAuctionWithProduct = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions/with-product",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesDeleteAuction = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions/{auctionId}",
        ...options,
    });
};
export const salesGetAuction = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/auctions/{auctionId}",
        ...options,
    });
};
export const salesCreateAuctionStart = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions/{auctionId}/start",
        ...options,
    });
};
export const salesListBids = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/auctions/{auctionId}/bids",
        ...options,
    });
};
export const salesCreateAuctionBid = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions/{auctionId}/bids",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateAuctionClose = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions/{auctionId}/end",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateAuctionWinnerReveal = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions/{auctionId}/reveal",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateAuctionPriceReduction = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/auctions/{auctionId}/price-reduction",
        ...options,
    });
};
export const salesListInstantPurchases = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/instant-purchases",
        ...options,
    });
};
export const salesCreateInstantPurchase = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/instant-purchases",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateInstantPurchaseWithProduct = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/instant-purchases/with-product",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesGetInstantPurchase = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/instant-purchases/{instantPurchaseId}",
        ...options,
    });
};
export const salesCreateInstantPurchaseOrder = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/instant-purchases/{instantPurchaseId}/purchase",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateInstantPurchaseEnd = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/instant-purchases/{instantPurchaseId}/end",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesUpdateInstantPurchaseQuantity = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/instant-purchases/{instantPurchaseId}/quantity",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateBackofficeInstantPurchaseEnd = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/instant-purchases/{instantPurchaseId}/end",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateBackofficeAuctionCancel = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/auctions/{auctionId}/cancel",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesGetBackofficeBroadcastSalesSettings = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcast-sales-settings",
        ...options,
    });
};
export const salesUpdateBackofficeBroadcastSalesSettings = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcast-sales-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingGetBackofficeBroadcastHostPresenceSettings = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcast-host-presence-settings",
        ...options,
    });
};
export const streamingUpdateBackofficeBroadcastHostPresenceSettings = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcast-host-presence-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesListBackofficeAnonymousNicknameWords = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/anonymous-nickname-words",
        ...options,
    });
};
export const salesCreateBackofficeAnonymousNicknameWord = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/anonymous-nickname-words",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesDeleteBackofficeAnonymousNicknameWord = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/anonymous-nickname-words/{wordId}",
        ...options,
    });
};
export const salesListGroupBuySales = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/sales/group-buys",
        ...options,
    });
};
export const salesCreateGroupBuySales = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/group-buys",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesGetGroupBuySales = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/sales/group-buys/{groupBuyId}",
        ...options,
    });
};
export const salesCreateSlotReservation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/group-buys/{groupBuyId}/slots/reserve",
        ...options,
    });
};
export const salesCreateGroupBuyBreakStart = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/group-buys/{groupBuyId}/break/start",
        ...options,
    });
};
export const salesCreateGroupBuyBreakCompletion = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/group-buys/{groupBuyId}/break/complete",
        ...options,
    });
};
export const salesCreateGroupBuyCancellation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/group-buys/{groupBuyId}/cancel",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateSlotRelease = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/group-buys/{groupBuyId}/slots/release",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateSlotPaymentConfirmation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/group-buys/{groupBuyId}/slots/confirm",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesListGiveaways = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/giveaways",
        ...options,
    });
};
export const salesCreateGiveaway = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/giveaways",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateGiveawayWithProduct = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/giveaways/with-product",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesGetGiveaway = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/giveaways/{giveawayId}",
        ...options,
    });
};
export const salesGetGiveawayEntryTerms = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/giveaways/{giveawayId}/entry-terms",
        ...options,
    });
};
export const salesCreateGiveawayEntry = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/giveaways/{giveawayId}/enter",
        ...options,
    });
};
export const salesCreateGiveawayDraw = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/giveaways/{giveawayId}/draw",
        ...options,
    });
};
export const salesCreateGiveawayEntriesClose = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/giveaways/{giveawayId}/close",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesCreateGiveawayWinnerAnnouncement = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/giveaways/{giveawayId}/announce",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const salesGetBroadcastProductCounts = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/broadcasts/{broadcastId}/product-counts",
        ...options,
    });
};
export const salesGetDefaultProductName = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/broadcasts/{broadcastId}/default-product-name",
        ...options,
    });
};
export const salesListBroadcastSoldListings = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/broadcasts/{broadcastId}/sold-listings",
        ...options,
    });
};
export const salesListBroadcastUnsoldListings = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/sales/broadcasts/{broadcastId}/unsold-listings",
        ...options,
    });
};
export const salesCreateMarketplacePurchase = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/marketplace-purchases",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingCreateBroadcast = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingCreateTestBroadcast = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/test",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingListLiveBroadcasts = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/broadcasts/live",
        ...options,
    });
};
export const streamingListLiveBroadcastCategoryIds = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/broadcasts/live/category-ids",
        ...options,
    });
};
export const streamingListScheduledBroadcasts = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/broadcasts/scheduled",
        ...options,
    });
};
export const streamingDeleteScheduledBroadcast = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/scheduled/{broadcastId}",
        ...options,
    });
};
export const streamingGetScheduledBroadcast = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/scheduled/{broadcastId}",
        ...options,
    });
};
export const streamingUpdateScheduledBroadcast = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/scheduled/{broadcastId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingListTrendingBroadcasts = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/broadcasts/trending",
        ...options,
    });
};
export const streamingListFeaturedBroadcasts = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/broadcasts/featured",
        ...options,
    });
};
export const streamingGetBroadcast = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/broadcasts/{broadcastId}",
        ...options,
    });
};
export const streamingCreateBroadcastStart = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/start",
        ...options,
    });
};
export const streamingCreateBroadcastEnd = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/end",
        ...options,
    });
};
export const streamingUpdateBroadcastTelemetrySession = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcast-telemetry-sessions/{telemetrySessionId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingUpdateBroadcastTelemetryWindow = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcast-telemetry-sessions/{telemetrySessionId}/windows/{windowIndex}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingGetBackofficeBroadcastTelemetrySession = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcast-telemetry-sessions/{telemetrySessionId}",
        ...options,
    });
};
export const streamingUpdateBroadcastConfig = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/config",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingUpdateAnnouncement = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/announcement",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingUpdateViewingMode = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/viewers/mode",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingGetChatHistory = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/broadcasts/{broadcastId}/chat",
        ...options,
    });
};
export const streamingCreateBroadcastChatMessage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/chat",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingCreateChatImage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/chat/image",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingDeleteChatMessage = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/chat/{chatId}",
        ...options,
    });
};
export const streamingCreateBroadcastChatBan = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/chat/ban-user",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingGetUserChatContext = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/chat/user-context",
        ...options,
    });
};
export const streamingGetLiveMemos = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/broadcasts/{broadcastId}/memos",
        ...options,
    });
};
export const streamingCreateLiveMemo = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/memos",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingDeleteLiveMemo = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/memos/{memoId}",
        ...options,
    });
};
export const streamingUpdateLiveMemo = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/memos/{memoId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingGetLiveMemoImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/memos/images/upload-url",
        ...options,
    });
};
export const streamingGetBroadcastScreenState = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/broadcasts/{broadcastId}/screen-state",
        ...options,
    });
};
export const streamingGetBroadcastSalesSummary = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/sales-summary",
        ...options,
    });
};
export const streamingGetBroadcastBuyerPresences = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/buyer-presences",
        ...options,
    });
};
export const streamingCreateBroadcastBuyerCall = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/buyer-calls",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingGetBroadcastViewerList = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/broadcasts/{broadcastId}/viewer-list",
        ...options,
    });
};
export const streamingGetAdjacentBroadcasts = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/broadcasts/{broadcastId}/adjacent",
        ...options,
    });
};
export const streamingListDealerBroadcasts = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/dealers/{dealerId}/broadcasts",
        ...options,
    });
};
export const streamingCreateAgoraChannel = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/agora/channels",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingCreateAgoraToken = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/agora/tokens/generate",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingCreateAgoraSessionHeartbeat = (options) => {
    return (options.client ?? client).post({
        url: "/api/v1/agora/sessions/heartbeats",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingDeleteAgoraSession = (options) => {
    return (options.client ?? client).delete({
        url: "/api/v1/agora/sessions/{sessionId}",
        ...options,
    });
};
export const streamingListBackofficeBroadcasts = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcasts",
        ...options,
    });
};
export const streamingDeleteBackofficeBroadcast = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcasts/{broadcastId}",
        ...options,
    });
};
export const streamingListBackofficeBroadcastChatMessages = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcasts/{broadcastId}/chat",
        ...options,
    });
};
export const streamingDeleteBackofficeBroadcastChatMessage = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcasts/{broadcastId}/chat/{chatId}",
        ...options,
    });
};
export const streamingCreateBackofficeBroadcastForceEnd = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcasts/{broadcastId}/force-end",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const streamingDeleteBroadcastReminder = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/reminders",
        ...options,
    });
};
export const streamingGetBroadcastReminder = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/reminders",
        ...options,
    });
};
export const streamingCreateBroadcastReminder = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/{broadcastId}/reminders",
        ...options,
    });
};
export const streamingGetBroadcastThumbnailUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/broadcasts/thumbnails/upload-url",
        ...options,
    });
};
export const messagingListBackofficeSupportChatRooms = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/support-chats",
        ...options,
    });
};
export const messagingCreateBackofficeSupportChatRoom = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/support-chats",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingGetBackofficeSupportChatHistory = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/support-chats/{chatRoomId}/messages",
        ...options,
    });
};
export const messagingCreateBackofficeSupportChatMessage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/support-chats/{chatRoomId}/messages",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateBackofficeSupportChatReadReceipt = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/support-chats/{chatRoomId}/reads",
        ...options,
    });
};
export const messagingListMyChatRooms = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/my-chat-rooms",
        ...options,
    });
};
export const messagingListChatRooms = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms",
        ...options,
    });
};
export const messagingCreateChatRoom = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingDeleteChatRoomMembership = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms/{chatRoomId}",
        ...options,
    });
};
export const messagingGetChatRoom = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms/{chatRoomId}",
        ...options,
    });
};
export const messagingGetChatHistory = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms/{chatRoomId}/messages",
        ...options,
    });
};
export const messagingCreateChatRoomMessage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms/{chatRoomId}/messages",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingDeleteMessage = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms/{chatRoomId}/messages/{messageId}",
        ...options,
    });
};
export const messagingCreateChatRoomImage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms/{chatRoomId}/images",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateChatRoomReadReceipt = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/chat-rooms/{chatRoomId}/reads",
        ...options,
    });
};
export const messagingListOpenChatRooms = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms",
        ...options,
    });
};
export const messagingListCommunityHomeOpenChatRooms = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/open-chat-rooms/community-home",
        ...options,
    });
};
export const messagingDeleteOpenChatRoom = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}",
        ...options,
    });
};
export const messagingGetOpenChatRoom = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}",
        ...options,
    });
};
export const messagingUpdateOpenChatRoomNotice = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateOpenChatRoomMembership = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}/join",
        ...options,
    });
};
export const messagingDeleteOpenChatRoomMembership = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}/leave",
        ...options,
    });
};
export const messagingListOpenChatRoomParticipants = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}/participants",
        ...options,
    });
};
export const messagingListOpenChatMessages = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/open-chat-rooms/{openChatRoomId}/messages",
        ...options,
    });
};
export const messagingCreateOpenChatRoomMessage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}/messages",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateOpenChatImage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}/messages/image",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingDeleteOpenChatRoomMessage = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/open-chat-rooms/{openChatRoomId}/messages/{messageId}",
        ...options,
    });
};
export const messagingListBackofficeOpenChatRooms = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms",
        ...options,
    });
};
export const messagingCreateBackofficeOpenChatRoom = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateBackofficeOpenChatRoomClose = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/close",
        ...options,
    });
};
export const messagingListBackofficeMessages = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/messages",
        ...options,
    });
};
export const messagingCreateBackofficeOpenChatRoomKickUser = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/kick-user",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateBackofficeOpenChatRoomUpdateCategory = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/update-category",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateBackofficeOpenChatRoomUpdateTitle = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/update-title",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingCreateBackofficeOpenChatRoomUpdateThumbnail = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/update-thumbnail",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingGetBackofficeOpenChatRoomThumbnailUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/thumbnails/upload-url",
        ...options,
    });
};
export const messagingGetBackofficeOpenChatRoomKickedUsers = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/kicked-users",
        ...options,
    });
};
export const messagingDeleteBackofficeOpenChatRoomKickedUser = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/kicked-users/{userId}",
        ...options,
    });
};
export const messagingGetBackofficeDealerChatRoomSettings = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/dealer-chat-room-settings",
        ...options,
    });
};
export const messagingUpdateBackofficeDealerChatRoomSettings = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/dealer-chat-room-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingListDealerChatRooms = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/dealer-chat-rooms",
        ...options,
    });
};
export const messagingCreateDealerChatRoom = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealer-chat-rooms",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingGetDealerChatRoomCreationEligibility = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealer-chat-rooms/creation-eligibility",
        ...options,
    });
};
export const messagingCreateDealerChatRoomKickUser = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealer-chat-rooms/{openChatRoomId}/kick-user",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const messagingListBackofficeOpenChatRoomMessages = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/messages",
        ...options,
    });
};
export const messagingDeleteBackofficeOpenChatRoomMessage = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/open-chat-rooms/{openChatRoomId}/messages/{messageId}",
        ...options,
    });
};
export const messagingListBackofficeDmConversations = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/dm-conversations",
        ...options,
    });
};
export const messagingListBackofficeDmConversationMessages = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/dm-conversations/{chatRoomId}/messages",
        ...options,
    });
};
export const notificationListNotifications = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/notifications",
        ...options,
    });
};
export const notificationPatchNotification = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/notifications/{notificationId}",
        ...options,
    });
};
export const notificationCreateNotificationOpen = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/notifications/opens",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationListUnreadNotifications = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/notifications/unread",
        ...options,
    });
};
export const notificationGetNotificationPreferences = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/notification-preferences/{userId}",
        ...options,
    });
};
export const notificationUpdateNotificationPreferences = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/notification-preferences/{userId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationUpdateAllNotificationsRead = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/notifications/reads",
        ...options,
    });
};
export const notificationListBroadcastPushSendHistories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcast-push-send-histories",
        ...options,
    });
};
export const notificationCreateBroadcastPushSendHistory = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/broadcast-push-send-histories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationListNotificationSettingItems = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/notification-setting-items",
        ...options,
    });
};
export const notificationUpdateNotificationSettingItem = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/notification-setting-items/{key}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationListBackofficeNotificationSettingItems = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-setting-items",
        ...options,
    });
};
export const notificationUpdateBackofficeNotificationSettingItem = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-setting-items/{key}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationListBackofficeUserNotificationSettingItems = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/notification-setting-items",
        ...options,
    });
};
export const notificationListBackofficeNotifications = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notifications",
        ...options,
    });
};
export const notificationGetNotificationOperationSettings = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-operation-settings",
        ...options,
    });
};
export const notificationUpdateNotificationOperationSettings = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-operation-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationListBackofficeNotificationTemplates = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-templates",
        ...options,
    });
};
export const notificationUpdateBackofficeNotificationTemplate = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-templates/{code}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationListNotificationDispatches = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-dispatches",
        ...options,
    });
};
export const notificationCreateNotificationDispatch = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-dispatches",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationCreateNotificationDispatchPreview = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-dispatches/previews",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationSearchNotificationDispatchRecipients = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-dispatches/recipient-previews",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const notificationListNotificationDispatchAlimtalkTemplates = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-dispatches/alimtalk-templates",
        ...options,
    });
};
export const notificationCreateNotificationDispatchCancellation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notification-dispatches/{dispatchId}/cancellations",
        ...options,
    });
};
export const settlementListSettlements = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/settlements",
        ...options,
    });
};
export const settlementCreateSettlement = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/settlements",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementGetSettlementDetails = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/settlements/{settlementId}",
        ...options,
    });
};
export const settlementCreateSettlementPayout = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/settlements/{settlementId}/process-payout",
        ...options,
    });
};
export const settlementUpdatePayoutSuccess = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/settlements/{settlementId}/confirm",
        ...options,
    });
};
export const settlementUpdatePayoutFailed = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/settlements/{settlementId}/fail",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementGetSettlementAccount = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealers/{dealerId}/settlement-account",
        ...options,
    });
};
export const settlementCreateSettlementAccount = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealers/{dealerId}/settlement-account",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementCreateSettlementReport = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/settlements/reports/excel",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementListBackofficeSettlements = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements",
        ...options,
    });
};
export const settlementCreateBackofficeSettlementBatchChangeStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/batch-change-status",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementCreateBackofficeSettlementBatchCompletion = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/batch-completions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementCreateBackofficeSettlementBatchStartProcessing = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/batch-start-processing",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementCreateBackofficeSettlementProcessStart = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/process/start",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementCreateBackofficeSettlementProcessComplete = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/process/complete",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementCreateBackofficeSettlementProcessCancel = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/process/cancel",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const settlementListBackofficeSettlementExports = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/exports",
        ...options,
    });
};
export const settlementGetBackofficeSettlement = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/{settlementId}",
        ...options,
    });
};
export const settlementCreateBackofficeSettlementReversal = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlements/{settlementId}/reversals",
        ...options,
    });
};
export const settlementListDealerOffsets = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/settlement/dealers/{dealerId}/offsets",
        ...options,
    });
};
export const settlementUpdatePaymentAgencyCallback = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                name: "X-Payment-Agency-Key",
                type: "apiKey",
            },
        ],
        url: "/api/webhooks/payment-agency/settlement-callback",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkCreateInvitation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/invitations",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkUpdateInvitation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/invitations/{invitationId}/accept",
        ...options,
    });
};
export const socialNetworkListInvitations = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/invitations",
        ...options,
    });
};
export const socialNetworkCreateUserFollow = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/follow",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkDeleteUserFollow = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/follow/{targetUserId}",
        ...options,
    });
};
export const socialNetworkListFollowers = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/followers",
        ...options,
    });
};
export const socialNetworkListFollowing = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/following",
        ...options,
    });
};
export const socialNetworkCreateUserBlock = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/block",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkDeleteUserBlock = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/block/{targetUserId}",
        ...options,
    });
};
export const socialNetworkListBlockedUsers = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/blocked",
        ...options,
    });
};
export const socialNetworkCreateReport = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/users/{userId}/report",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkListBackofficeUserBlockedUsers = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/blocked-users",
        ...options,
    });
};
export const socialNetworkGetPublicUserProfile = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/public/users/{userId}/profile",
        ...options,
    });
};
export const socialNetworkGetPublicFollowerStats = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/public/users/{userId}/follower-stats",
        ...options,
    });
};
export const socialNetworkListReports = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/reports",
        ...options,
    });
};
export const socialNetworkGetReport = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/reports/{reportId}",
        ...options,
    });
};
export const socialNetworkUpdateReport = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/reports/{reportId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkListActiveReportReasonCategories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/report-reason-categories",
        ...options,
    });
};
export const socialNetworkListReportReasonCategories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/admin/report-reason-categories",
        ...options,
    });
};
export const socialNetworkCreateReportReasonCategory = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/admin/report-reason-categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkDeleteReportReasonCategory = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/admin/report-reason-categories/{categoryId}",
        ...options,
    });
};
export const socialNetworkGetReportReasonCategory = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/admin/report-reason-categories/{categoryId}",
        ...options,
    });
};
export const socialNetworkUpdateReportReasonCategory = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/admin/report-reason-categories/{categoryId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkListLoungePosts = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/lounges/posts",
        ...options,
    });
};
export const socialNetworkCreateLoungePost = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkDeleteLoungePost = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts/{postId}",
        ...options,
    });
};
export const socialNetworkGetLoungePost = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/lounges/posts/{postId}",
        ...options,
    });
};
export const socialNetworkUpdateLoungePost = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts/{postId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkDeleteLoungePostLike = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts/{postId}/likes",
        ...options,
    });
};
export const socialNetworkCreateLoungePostLike = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts/{postId}/likes",
        ...options,
    });
};
export const socialNetworkListLoungeComments = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts/{postId}/comments",
        ...options,
    });
};
export const socialNetworkCreateLoungeComment = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts/{postId}/comments",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkDeleteLoungeComment = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/comments/{commentId}",
        ...options,
    });
};
export const socialNetworkUpdateLoungeComment = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/comments/{commentId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkListLoungeCommentReplies = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/comments/{commentId}/replies",
        ...options,
    });
};
export const socialNetworkCreateLoungeCommentReply = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/comments/{commentId}/replies",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkDeleteLoungeCommentLike = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/comments/{commentId}/likes",
        ...options,
    });
};
export const socialNetworkCreateLoungeCommentLike = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/comments/{commentId}/likes",
        ...options,
    });
};
export const socialNetworkListMyLoungeComments = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/comments/mine",
        ...options,
    });
};
export const socialNetworkGetLoungePostImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/lounges/posts/images/upload-url",
        ...options,
    });
};
export const socialNetworkGetMyReferralLink = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/referral-links/my",
        ...options,
    });
};
export const socialNetworkCreateMyReferralLink = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/referral-links/my",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkGetMyReferralStats = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/referral-links/my/stats",
        ...options,
    });
};
export const socialNetworkListMyReferredUsers = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/referral-links/my/referred-users",
        ...options,
    });
};
export const socialNetworkListBackofficeLoungePosts = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/posts",
        ...options,
    });
};
export const socialNetworkGetBackofficeLoungePost = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/posts/{postId}",
        ...options,
    });
};
export const socialNetworkCreateBackofficeLoungePostDeletion = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/posts/{postId}/delete",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const socialNetworkCreateBackofficeLoungePostPin = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/posts/{postId}/pin",
        ...options,
    });
};
export const socialNetworkCreateBackofficeLoungePostUnpin = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/posts/{postId}/unpin",
        ...options,
    });
};
export const socialNetworkListBackofficeLoungePostComments = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/posts/{postId}/comments",
        ...options,
    });
};
export const socialNetworkListBackofficeLoungeCommentReplies = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/comments/{commentId}/replies",
        ...options,
    });
};
export const socialNetworkCreateBackofficeLoungeCommentDeletion = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/lounge/comments/{commentId}/delete",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const liveSnapshotListLiveSnapshots = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/live-snapshots",
        ...options,
    });
};
export const liveSnapshotCreateLiveSnapshot = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/live-snapshots",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const liveSnapshotGetLiveSnapshotImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/live-snapshots/images/upload-url",
        ...options,
    });
};
export const liveSnapshotListLiveSnapshotBuyers = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/live-snapshots/broadcasts/{broadcastId}/buyers",
        ...options,
    });
};
export const liveSnapshotGetLiveSnapshot = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/live-snapshots/{liveSnapshotId}",
        ...options,
    });
};
export const liveSnapshotDeleteLiveSnapshot = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/live-snapshots/{liveSnapshotId}/delete",
        ...options,
    });
};
export const liveSnapshotListBackofficeLiveSnapshots = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/live-snapshots",
        ...options,
    });
};
export const liveSnapshotGetBackofficeLiveSnapshot = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/live-snapshots/{liveSnapshotId}",
        ...options,
    });
};
export const liveSnapshotPatchBackofficeLiveSnapshotHideStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/live-snapshots/{liveSnapshotId}/hide",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const liveSnapshotPatchBackofficeLiveSnapshotUnhideStatus = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/live-snapshots/{liveSnapshotId}/unhide",
        ...options,
    });
};
export const ledgerListAccounts = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/accounts",
        ...options,
    });
};
export const ledgerCreateAccount = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/accounts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ledgerDeleteAccount = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/accounts/{accountId}",
        ...options,
    });
};
export const ledgerGetAccount = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/accounts/{accountId}",
        ...options,
    });
};
export const ledgerUpdateAccount = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/accounts/{accountId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ledgerGetAccountBalance = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/accounts/{accountId}/balance",
        ...options,
    });
};
export const ledgerListJournalEntries = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/journal-entries",
        ...options,
    });
};
export const ledgerCreateJournalEntry = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/journal-entries",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ledgerGetJournalEntry = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/journal-entries/{entryId}",
        ...options,
    });
};
export const ledgerCreateReversingJournalEntry = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/journal-entries/{entryId}/reverse",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ledgerListReconciliationReports = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/reconciliation",
        ...options,
    });
};
export const ledgerCreateReconciliation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/reconciliation",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const ledgerGetReconciliationReport = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/reconciliation/{reportId}",
        ...options,
    });
};
export const ledgerListDiscrepancies = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/reconciliation/{reportId}/discrepancies",
        ...options,
    });
};
export const ledgerGetDealerBalance = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/dealers/{dealerId}/balance",
        ...options,
    });
};
export const ledgerGetTrialBalance = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/trial-balance",
        ...options,
    });
};
export const ledgerCreateControlAccountReconciliation = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/ledger/reconciliation/control-accounts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const pointGetMyPointBalance = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/points/my/balance",
        ...options,
    });
};
export const pointListMyPointTransactions = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/points/my/transactions",
        ...options,
    });
};
export const pointGetBackofficeUserPointBalance = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/points/balance",
        ...options,
    });
};
export const pointListBackofficeUserPointTransactions = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/points/transactions",
        ...options,
    });
};
export const pointCreateBackofficeUserPointCredit = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/points/credits",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const pointCreateBackofficeUserPointDebit = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/users/{userId}/points/debits",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const marketplacePaymentGetCallback = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/marketplace-payments/callbacks",
        ...options,
    });
};
export const marketplacePaymentListBrandPayPaymentMethods = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/brandpay/payment-methods",
        ...options,
    });
};
export const marketplacePaymentCreateBrandPayPaymentMethodDefault = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/brandpay/payment-methods/main",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const marketplacePaymentDeleteBrandPayPaymentMethod = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/brandpay/payment-methods/{methodKey}",
        ...options,
    });
};
export const marketplacePaymentGetBrandPayRegistrationStatus = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/brandpay/registration-status",
        ...options,
    });
};
export const contentManagementListBanners = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/banners",
        ...options,
    });
};
export const contentManagementCreateBanner = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/banners",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const contentManagementUpdateBannerDisplayOrders = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/banners/display-orders",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const contentManagementGetBannerImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/banners/images/upload-url",
        ...options,
    });
};
export const contentManagementDeleteBanner = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/banners/{bannerId}",
        ...options,
    });
};
export const contentManagementGetBanner = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/banners/{bannerId}",
        ...options,
    });
};
export const contentManagementUpdateBanner = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/banners/{bannerId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const contentManagementListPublicBanners = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/public/banners",
        ...options,
    });
};
export const contentManagementListNotices = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notices",
        ...options,
    });
};
export const contentManagementCreateNotice = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notices",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const contentManagementDeleteNotice = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notices/{noticeId}",
        ...options,
    });
};
export const contentManagementGetNotice = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notices/{noticeId}",
        ...options,
    });
};
export const contentManagementUpdateNotice = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/notices/{noticeId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const contentManagementGetContentFileUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/content-files/upload-url",
        ...options,
    });
};
export const contentManagementListContentPages = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/content-pages",
        ...options,
    });
};
export const contentManagementCreateContentPage = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/content-pages",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const contentManagementDeleteContentPage = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/content-pages/{pageId}",
        ...options,
    });
};
export const contentManagementGetContentPage = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/content-pages/{pageId}",
        ...options,
    });
};
export const contentManagementUpdateContentPage = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/content-pages/{pageId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const contentManagementListPublicNotices = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/public/notices",
        ...options,
    });
};
export const contentManagementGetPublicNotice = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/public/notices/{noticeId}",
        ...options,
    });
};
export const contentManagementListPublicNoticePopups = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/public/notice-popups",
        ...options,
    });
};
export const contentManagementListPublicNoticeBanners = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/public/notice-banners",
        ...options,
    });
};
export const contentManagementGetPublicContentPage = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/public/content-pages/{pageId}",
        ...options,
    });
};
export const platformConfigGetCommissionConfig = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/commission-rates",
        ...options,
    });
};
export const platformConfigUpdateCommissionConfig = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/commission-rates",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetPgFeeConfig = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/pg-fee-rates",
        ...options,
    });
};
export const platformConfigUpdatePgFeeConfig = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/pg-fee-rates",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetSettlementConfig = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/settlement-configs",
        ...options,
    });
};
export const platformConfigUpdateSettlementConfig = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/settlement-configs",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetFeeRates = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/fee-rates",
        ...options,
    });
};
export const platformConfigGetAppVersionPolicies = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/app-version-policies",
        ...options,
    });
};
export const platformConfigUpdateAppVersionPolicy = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/app-version-policies/{platform}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetBoltbMarketSectionAllowedCategories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/boltb-market-section-allowed-categories",
        ...options,
    });
};
export const platformConfigUpdateBoltbMarketSectionAllowedCategories = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/boltb-market-section-allowed-categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetMobileRuntimePolicies = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/mobile-runtime-policies",
        ...options,
    });
};
export const platformConfigUpdateMobileRuntimePolicy = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/mobile-runtime-policies/{platform}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetCompanyInfo = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/company-info-settings",
        ...options,
    });
};
export const platformConfigUpdateCompanyInfo = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/company-info-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetAppDownloadSettings = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/app-download-settings",
        ...options,
    });
};
export const platformConfigUpdateAppDownloadSettings = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/app-download-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetBroadcastChatNotices = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/broadcast-chat-notices",
        ...options,
    });
};
export const platformConfigCreateBroadcastChatNotice = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/broadcast-chat-notices",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigUpdateBroadcastChatNoticeOrder = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/broadcast-chat-notices/order",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigUpdateBroadcastChatNotice = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/broadcast-chat-notices/{noticeId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetBroadcastChatNoticeSettings = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/broadcast-chat-notice-settings",
        ...options,
    });
};
export const platformConfigUpdateBroadcastChatNoticeSettings = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/broadcast-chat-notice-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigListChatBannedWords = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/chat-banned-words",
        ...options,
    });
};
export const platformConfigCreateChatBannedWord = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/chat-banned-words",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigDeleteChatBannedWord = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/chat-banned-words/{wordId}",
        ...options,
    });
};
export const platformConfigGetAppUiSettings = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/app-ui-settings",
        ...options,
    });
};
export const platformConfigUpdateAppUiSettings = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/app-ui-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigCreateAppUiSettingReset = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/app-ui-settings/resets",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigListUiConfigFiles = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/ui-config-files",
        ...options,
    });
};
export const platformConfigGetUiConfigFile = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/ui-config-files/{name}",
        ...options,
    });
};
export const platformConfigDeleteUiConfigDraft = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/ui-config-files/{name}/drafts",
        ...options,
    });
};
export const platformConfigUpdateUiConfigDraft = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/ui-config-files/{name}/drafts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigCreateUiConfigPublish = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/ui-config-files/{name}/publishes",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigCreateUiConfigRevert = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/ui-config-files/{name}/reverts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigUpdateUiConfigSwitches = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/platform-config/ui-config-files/{name}/switches",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const platformConfigGetPublicMobileRuntimePolicy = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/mobile-runtime-policies",
        ...options,
    });
};
export const platformConfigGetPublicAppVersionPolicies = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/app-version-policies",
        ...options,
    });
};
export const platformConfigGetPublicBoltbMarketSectionAllowedCategories = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/boltb-market-section-allowed-categories",
        ...options,
    });
};
export const platformConfigGetPublicCompanyInfo = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/company-info-settings",
        ...options,
    });
};
export const platformConfigGetPublicAppDownloadSettings = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/app-download-settings",
        ...options,
    });
};
export const platformConfigGetPublicBroadcastChatNoticeSettings = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/broadcast-chat-notice-settings",
        ...options,
    });
};
export const platformConfigGetAppSyncChanges = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/app-sync-changes",
        ...options,
    });
};
export const platformConfigGetPublicUiConfigManifest = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/ui-config-files",
        ...options,
    });
};
export const platformConfigGetPublicUiConfigVersion = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/ui-config-files/{name}/versions/{version}",
        ...options,
    });
};
export const platformConfigGetPublicPage = (options) => {
    return (options.client ?? client).get({
        url: "/api/v1/pages/{slug}",
        ...options,
    });
};
export const categoryListPublicCategories = (options) => {
    return (options?.client ?? client).get({
        url: "/api/v1/categories",
        ...options,
    });
};
export const categoryListCategories = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories",
        ...options,
    });
};
export const categoryCreateCategory = (options) => {
    return (options.client ?? client).post({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const categoryDeleteCategory = (options) => {
    return (options.client ?? client).delete({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories/{categoryId}",
        ...options,
    });
};
export const categoryGetCategory = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories/{categoryId}",
        ...options,
    });
};
export const categoryUpdateCategory = (options) => {
    return (options.client ?? client).patch({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories/{categoryId}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const categoryGetCategoryImageUploadUrl = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories/images/upload-url",
        ...options,
    });
};
export const categoryGetAllCategoryIconSetting = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories/all-icon-settings",
        ...options,
    });
};
export const categoryUpdateAllCategoryIconSetting = (options) => {
    return (options.client ?? client).put({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/categories/all-icon-settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });
};
export const kpiGetBackofficeKpiDashboard = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/kpi-dashboard",
        ...options,
    });
};
export const kpiListBackofficeKpiDashboardExports = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/backoffice/kpi-dashboard/exports",
        ...options,
    });
};
export const dealerBackofficeGetDashboardSummary = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealer-backoffice/dashboard/summary",
        ...options,
    });
};
export const dealerBackofficeListSalesHistory = (options) => {
    return (options?.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealer-backoffice/sales-history",
        ...options,
    });
};
export const dealerBackofficeGetBuyerNewOrderGroup = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealer-backoffice/buyers/{buyerId}/new-orders",
        ...options,
    });
};
export const dealerBackofficeListBuyerHistories = (options) => {
    return (options.client ?? client).get({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/v1/dealer-backoffice/buyers/{buyerId}/histories",
        ...options,
    });
};
//# sourceMappingURL=sdk.gen.js.map